'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var react = require('react');
var InputStepper = require('@andes/input-stepper');
var button = require('@andes/button');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var InputStepper__default = /*#__PURE__*/_interopDefaultLegacy(InputStepper);
var REACT_ELEMENT_TYPE;
function _createRawReactElement(e, r, E, l) {
  REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
var CardAction = function CardAction(_ref) {
  var namespace = _ref.namespace,
    layout = _ref.layout,
    onAddToCart = _ref.onAddToCart,
    relevant = _ref.relevant,
    cta = _ref.cta,
    ctaMobile = _ref.cta_mobile,
    variationsCta = _ref.cta_for_multiple_variations,
    variationsCtaMobile = _ref.cta_for_multiple_variations_mobile,
    buyNowCta = _ref.cta_for_buy_now,
    buyNowCtaMobile = _ref.cta_for_buy_now_mobile,
    isCartEligible = _ref.isCartEligible,
    itemQuantity = _ref.itemQuantity,
    hasMoreVariations = _ref.hasMoreVariations,
    netWeight = _ref.netWeight,
    purchaseMaxQuantity = _ref.purchaseMaxQuantity,
    incrementQuantity = _ref.incrementQuantity,
    decrementQuantity = _ref.decrementQuantity,
    deviceType = _ref.deviceType,
    cartTextLabel = _ref.cart_text_label,
    isEditable = _ref.isEditable;
  var isDesktop = deviceType === 'desktop';
  var _useState = react.useState(cta),
    _useState2 = _slicedToArray(_useState, 2),
    callToAction = _useState2[0],
    setCallToAction = _useState2[1];
  react.useEffect(function () {
    if (hasMoreVariations) {
      setCallToAction(isDesktop ? variationsCta : variationsCtaMobile);
    } else if (isCartEligible) {
      setCallToAction(isDesktop ? cta : ctaMobile);
    } else {
      setCallToAction(isDesktop ? buyNowCta : buyNowCtaMobile);
    }
  }, [deviceType]);
  var incrementButtonProps = {
    onClick: incrementQuantity
  };
  var decrementButtonProps = {
    onClick: decrementQuantity
  };
  var setUnit = function setUnit(quantity) {
    var val = quantity * netWeight.number;
    if (val >= 1000) {
      return "".concat(val / 1000, " kg");
    }
    return "".concat(val, " ").concat(netWeight.unit);
  };
  var convertQuantityToUnit = function convertQuantityToUnit(quantity) {
    if (netWeight) {
      return setUnit(quantity);
    }
    return quantity;
  };
  var handleCtaClick = function handleCtaClick(e) {
    if (isEditable) {
      return;
    }
    onAddToCart(e);
  };
  if (itemQuantity > 0 && !hasMoreVariations) {
    return /*#__PURE__*/_createRawReactElement(InputStepper__default["default"], {
      formatValue: convertQuantityToUnit,
      value: itemQuantity,
      size: "small",
      step: 1,
      maxValue: purchaseMaxQuantity,
      decrementButtonProps: decrementButtonProps,
      incrementButtonProps: incrementButtonProps,
      complementaryText: isDesktop && cartTextLabel
    });
  }
  return /*#__PURE__*/_createRawReactElement(button.Button, {
    className: "".concat(namespace, "__cta-button--").concat(layout),
    onClick: handleCtaClick,
    hierarchy: relevant ? 'loud' : 'quiet',
    size: "medium",
    fullWidth: layout === 'column'
  }, void 0, callToAction);
};
CardAction.defaultProps = {
  netWeight: null,
  namespace: 'ui-ms-card-action',
  isEditable: false
};
var CardAction$1 = CardAction;
exports.CardAction = CardAction$1;
exports["default"] = CardAction$1;
